import _ from "lodash";

const CommonHelper = {
    linkTo(patientUrl: string, withScroll = true) {
        const url = window.location.origin + window.location.pathname + "#" + patientUrl;
        // let url = window.location.origin + window.location.pathname + patientUrl;
        window.location.href = url;
        if (withScroll) {
            try {
                (document as any).getElementById(`scrollWrapper`).scrollTo({ top: 0, behavior: "auto" });
            } catch (error) {}
            try {
                window.scrollTo({ top: 0, behavior: "auto" });
            } catch (error) {}
        }
    },

    downloadFile(filename: string, text: string) {
        let element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
        element.setAttribute("download", filename);
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        try {
            document.body.removeChild(element);
        } catch (exc) {}
    },

    downloadURI(uri: string, name: string) {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        try {
            document.body.removeChild(link);
        } catch (exc) {}
    },

    async copyToClipboard(text: string) {
        if ((window as any)?.clipboardData?.setData) {
            return (window as any)?.clipboardData?.setData?.("Text", text);
        }
        if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            } finally {
                try {
                    document.body.removeChild(textarea);
                } catch (exc) {}
            }
        }
    },

    objectStringToPath: (path: string) => {
        return (
            path
                ?.replaceAll?.(`[`, `.`)
                ?.replaceAll?.(/[\?\]\"\'\`]/g, ``)
                ?.replaceAll?.(`..`, `.`)
                ?.split?.(`.`)
                ?.filter?.((i: any) => i?.length) ?? []
        );
    },

    objectPut: (obj: any, stringPath: string, val: any) => {
        _.set(obj, stringPath, val);
    },

    objectMerge: (obj: any, path: string, val: any) => {
        // Source: https://vanillajstoolkit.com/helpers/put/
        const pathArray = CommonHelper.objectStringToPath(path);
        let length = pathArray.length;
        let current = obj;
        pathArray.forEach((key: string, index: number) => {
            let isArray = key.slice(-2) === "[]";
            key = isArray ? key.slice(0, -2) : key;
            if (isArray && !Array.isArray(current[key])) {
                current[key] = [];
            }
            if (index === length - 1) {
                if (isArray) {
                    current[key] = [...current[key], ...val];
                } else {
                    current[key] = { ...current[key], ...val };
                }
            } else {
                if (!current[key]) {
                    current[key] = {};
                }
                current = current[key];
            }
        });
    },

    objectGet: (obj: any, path: string) => _.get(obj, path),

    objectCopy: (obj: any) => _.cloneDeep(obj),

    objectCompare: (o1: any, o2: any) => _.isEqual(o1, o2),

    objectFlatten: (obj: any): any => {
        Object.keys(obj)
            ?.filter?.((key) => typeof obj[key] === `object`)
            .forEach?.((key) => {
                Object.keys(obj?.[key] ?? {})?.forEach?.((innerKey) => {
                    obj[`${key}.${innerKey}`] = obj[key][innerKey];
                });
                obj = _.omit(obj, key);
            });
        return Object.keys(obj)?.filter?.((key) => typeof obj[key] === `object`).length > 0 ? CommonHelper.objectFlatten(obj) : obj;
    },

    objectNested: (obj: any) => {
        let newObj = {};
        Object.keys(obj).forEach((key) => {
            _.set(newObj, key, obj[key]);
        });
        return newObj;
    },

    objectDiff: (o1 = {}, o2 = {}) => {
        const o1flatten = CommonHelper.objectFlatten(o1);
        const o2flatten = CommonHelper.objectFlatten(o2);
        return {
            incoming: CommonHelper.objectNested(
                Object.fromEntries(
                    Object.keys(o2flatten)
                        .filter((key) => !o1flatten?.hasOwnProperty?.(key) || o1flatten[key] !== o2flatten[key])
                        .map((key) => [key, o2flatten[key]]),
                ),
            ),
            outcoming: CommonHelper.objectNested(
                Object.fromEntries(
                    Object.keys(o1flatten)
                        .filter((key) => !o2flatten?.hasOwnProperty?.(key) || o2flatten[key] !== o1flatten[key])
                        .map((key) => [key, o1flatten[key]]),
                ),
            ),
            changes: {
                prev: CommonHelper.objectNested(
                    Object.fromEntries(
                        Object.keys(o1flatten)
                            .filter((key) => o2flatten?.hasOwnProperty?.(key) && o1flatten?.[key] !== o2flatten?.[key])
                            .map((key) => [key, o1flatten[key]]),
                    ),
                ),
                next: CommonHelper.objectNested(
                    Object.fromEntries(
                        Object.keys(o1flatten)
                            .filter((key) => o2flatten?.hasOwnProperty?.(key) && o1flatten?.[key] !== o2flatten?.[key])
                            .map((key) => [key, o2flatten[key]]),
                    ),
                ),
                fresh: CommonHelper.objectNested(
                    Object.fromEntries(
                        Object.keys(o2flatten)
                            .filter((key) => !o1flatten?.hasOwnProperty?.(key))
                            .map((key) => [key, o2flatten[key]]),
                    ),
                ),
                revoked: CommonHelper.objectNested(
                    Object.fromEntries(
                        Object.keys(o1flatten)
                            .filter((key) => !o2flatten?.hasOwnProperty?.(key))
                            .map((key) => [key, o1flatten[key]]),
                    ),
                ),
                flatten: Object.fromEntries(
                    Object.keys(o1flatten)
                        .filter((key) => o2flatten?.hasOwnProperty?.(key) && o1flatten?.[key] !== o2flatten?.[key])
                        .map((key) => [key, { prev: o1flatten[key], next: o2flatten[key] }]),
                ),
            },
        };
    },

    format: (value: any, pattern: string) => {
        let i = 0,
            v = value?.toString();
        return pattern?.replace(/#/g, (_) => v?.[i++] ?? ``);
    },

    QSToObject: (search: string | URLSearchParams) => {
        if (search instanceof String) {
            search = new URLSearchParams(search);
        }

        return Object.fromEntries(Array.from((search as URLSearchParams).keys()).map((i) => [i, (search as URLSearchParams).get(i)]));
    },

    objectToQS: (obj = {}) => (_.isEmpty(obj) ? `` : `?`) + new URLSearchParams(obj).toString(),

    getElementClassPath: (element: any) => {
        let path = [];
        path.push(element?.className);
        const goToParent = (element: any) => {
            path.push(element?.className);
            if (element?.parentNode) {
                goToParent(element?.parentNode);
            }
        };
        goToParent(element);
        return path;
    },

    getElementParrentsPath: (element: any) => {
        let path = [];
        path.push(element);
        const goToParent = (element: any) => {
            path.push(element);
            if (element?.parentNode) {
                goToParent(element?.parentNode);
            }
        };
        goToParent(element);
        return path;
    },

    stringImposition: (s1: string, s2: string) =>
        s1
            ?.trim?.()
            ?.toLowerCase?.()
            ?.includes?.(s2?.trim?.()?.toLowerCase?.() ?? ``) ?? false,

    sha256: async (message: any) => {
        // encode as UTF-8
        const msgBuffer = new TextEncoder().encode(message);

        // hash the message
        const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // convert bytes to hex string
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
        return hashHex;
    },

    groupByMultiple: (array: any[], ...groupBy: string[]) => {
        const inner = (i: any[], index: number = 0) =>
            groupBy[index]
                ? _(i)
                      .groupBy(groupBy[index])
                      .mapValues((i) => inner(i, index + 1))
                      .value()
                : i;
        return inner(array);
    },
};

export default CommonHelper;

export const {
    objectToQS,
    QSToObject,
    copyToClipboard,
    objectPut,
    objectMerge,
    objectGet,
    objectCopy,
    objectCompare,
    objectFlatten,
    objectNested,
    objectDiff,
    format,
    linkTo,
    downloadFile,
    downloadURI,
    getElementClassPath,
    getElementParrentsPath,
    stringImposition,
    sha256,
    groupByMultiple,
} = CommonHelper;

export const isna = (item: any) => [undefined, null, ``].includes(item);

export const path = (s: string) => {
    if (Array.isArray(s)) {
        s = s[0];
    }
    let [stringPath, exeption] = s.split(` ?? `);
    return (ref: any) => CommonHelper.objectGet(ref, CommonHelper.objectStringToPath(stringPath).slice(1).join(`.`)) ?? exeption;
};

export let getType = (obj: any) =>
    ({}?.toString
        ?.call?.(obj)
        ?.match?.(/\s([a-zA-Z]+)/)?.[1]
        ?.toLowerCase?.());

export let createId = () =>
    Math.random()
        .toString(36)
        .substring(3)
        .split(``)
        .map((i) => i[Math.random() > 0.5 ? `toLowerCase` : `toUpperCase`]())
        .join(``);

export let sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export let validateOnlyDigits = (s: string) => /^\d+$/.test(s || `0`);

export let togglePush = (array = [], value: any) =>
    [...array, value].filter((i) => (array?.find?.((j) => _.isEqual(j, value)) ? !_.isEqual(i, value) : true));
